import {Redirect, Route, RouteProps} from "react-router";
import React, {Fragment, useState} from "react";
import {createGetCurrentLoginRequest} from "../../helpers/currentlogin-request-helpers";

import {Progress} from "../../parts/progress/Progress";
import {UserStatus} from "../model/user-model";
import {isProcessing} from "./helpers/verification-userlogin-status-helper";
import {getCurrentLoggedInUser} from "@simplyhealth/iam_client_lib/lib";


export const PrivateRoute = ({
                                 children,
                                 ...rest
                             }: RouteProps) => {

    const [isloginUser, setIsLoginUser] = useState<UserStatus>("Unknow");
    const renderRedirect = (props: RouteProps) => {
        return isloginUser === "LoggedIn" ? (children) : (<Redirect
            to={{
                pathname: '/',
                state: {from: props.location},
            }}
        />);
    };

    const req = createGetCurrentLoginRequest();
    getCurrentLoggedInUser(req).then((response) => {
        setIsLoginUser("LoggedIn");
    }).catch((error) => {
        setIsLoginUser("NotLoggedIn");
    });

    return (
        isProcessing(isloginUser) ?
            <Fragment>
                <Progress/>
            </Fragment> :
            <Route {...rest} render={renderRedirect}/>
    );
};